const isBrowser = typeof window !== 'undefined' || !import.meta.env.SSR

export default isBrowser
